import { render, staticRenderFns } from "./BulletedNotes.vue?vue&type=template&id=498a23ab&scoped=true&"
import script from "./BulletedNotes.vue?vue&type=script&lang=js&"
export * from "./BulletedNotes.vue?vue&type=script&lang=js&"
import style0 from "./BulletedNotes.vue?vue&type=style&index=0&id=498a23ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a23ab",
  null
  
)

export default component.exports